import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pallet, PalletSearchParams } from '../domain/inventory.model';

@Injectable({
  providedIn: 'root'
})
export class PalletService {

  private apiUrl = environment.apiUrl + '/api/v1/pallet';
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  validatePalletCode(warehouse: string, accountId: number, code: string): Observable<boolean> {
    const params = new HttpParams()
      .set('code', code);
    return this.http.get<boolean>(`${this.apiUrl}/${warehouse}/${accountId}/validate`, { params });
  }

  existingPalletCode(warehouse: string, code: string): Observable<Pallet> {
    const params = new HttpParams()
      .set('code', code);
    return this.http.get<Pallet>(`${this.apiUrl}/${warehouse}/existing`, { params });
  }

  searchItems(params: PalletSearchParams): Observable<{ content: Pallet[]; totalElements: number }> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http.get<{ content: Pallet[]; totalElements: number }>(`${this.apiUrl}/search/${params['warehouse']}`, { params: httpParams });
  }

  updatePallets(pallets: Pallet[]): Observable<void> {
    const url = `${this.apiUrl}/bulk`;
    return this.http.put<void>(url, pallets, this.httpOptions);
  }

  deletePallet(palletId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${palletId}`);
  }
}
